import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=7b7c010e&scoped=true&"
import script from "./Pix.vue?vue&type=script&lang=js&"
export * from "./Pix.vue?vue&type=script&lang=js&"
import style0 from "./Pix.vue?vue&type=style&index=0&id=7b7c010e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c010e",
  null
  
)

export default component.exports